"use client";

import styles from "./styles/selected-voice.module.scss";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import playVoiceIcon from "@/assets/music-player/play-secondary.svg";
import playHover from "@/assets/voices/card/play-hover.svg";
import stopPressed from "@/assets/music-player/stop-pressed.svg";
import IconStateButton from "@/components/pages/home/components/voices/icon-state-button";
import { useMobile } from "@/hooks/use-responsive";
import "react-toastify/dist/ReactToastify.css";
import SwitchVoiceButton from "@/components/pages/convert/components/convert-sidebar/components/switch-voice-button";
import VerticalSelectVoiceInput from "@/components/common/voice-selector/inputs/vertical-select-voice-input";
import { VoiceModel } from "@/actions/db/get-models";
import defaultIcon from "@/assets/models/default.webp";
import { ToastContainer } from "react-toastify";
import SelectedVoiceDropdown from "@/components/pages/convert/components/selected-voice-dropdown";
import CoverTooltip from "@/components/pages/convert/components/cover-tooltip";
import { audioManager } from "@/utils/audio-manager";

type SelectedVoiceProps = {
  selectedModel: VoiceModel | undefined;
  switchVoiceModalType: any;
};

const SelectedVoice = ({
  selectedModel,
  switchVoiceModalType,
}: SelectedVoiceProps) => {
  const { isMobile } = useMobile();
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayButtonClick = () => {
    if (!selectedModel?.audioPreviewUrl) return;

    if (isPlaying) {
      audioManager.pause();
      setIsPlaying(false);
    } else {
      audioManager.play(selectedModel.audioPreviewUrl);
      setIsPlaying(true);
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    return () => {
      audioManager.stop();
      setIsPlaying(false);
    };
  }, []);

  const icon = selectedModel?.thumbnail || defaultIcon;

  if (!selectedModel?.name) {
    return (
      <VerticalSelectVoiceInput modalType={{ type: switchVoiceModalType }} />
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.left_part}>
        <div className={styles.image_wrapper}>
          {selectedModel.audioPreviewUrl && (
            <div className={styles.play_button}>
              <IconStateButton
                baseIcon={playVoiceIcon}
                hoverIcon={playHover}
                activeIcon={stopPressed}
                onClick={handlePlayButtonClick}
                size={isMobile ? 30 : 28}
                isActive={isPlaying}
              />
            </div>
          )}
          <Image
            className={styles.image}
            src={icon}
            alt={icon.toString()}
            width={139}
            height={139}
          />
        </div>
        <div className={styles.info_column}>
          <div
            className={styles.title}
            data-tooltip-id="voiceTitle"
            data-tooltip-content={selectedModel.name}
          >
            {selectedModel.name}
          </div>
          <div className={styles.voice_additional_info_wrapper}>
            {selectedModel.gender && (
              <div className={styles.voice_additional_info}>
                {selectedModel.gender}
              </div>
            )}
            {selectedModel.categories?.map((item) => (
              <div key={item.id} className={styles.voice_additional_info}>
                {item.categoryName}
              </div>
            ))}
          </div>
        </div>
        {!isMobile && (
          <div className={styles.share_wrapper}>
            <SelectedVoiceDropdown selectedModel={selectedModel} />
          </div>
        )}
      </div>
      <div className={styles.right_part}>
        <SwitchVoiceButton switchVoiceModalType={switchVoiceModalType} />
        {isMobile && <SelectedVoiceDropdown selectedModel={selectedModel} />}
      </div>
      <CoverTooltip id={"voiceTitle"} />
    </div>
  );
};

export default SelectedVoice;
